import Vue     from 'vue';
import { API } from '~/api/api';

Vue.prototype.$api = API;
